export const GET_LOAN_MERGES = 'loan_merges/GET_LOAN_MERGES'
export const ADD_LOAN_MERGE = 'loan_merges/ADD_LOAN_MERGE'
export const EDIT_LOAN_MERGE = 'loan_merges/EDIT_LOAN_MERGE'
export const SUBMIT_LOAN_MERGE = 'loan_merges/SUBMIT_LOAN_MERGE'
export const APPROVE_LOAN_MERGE = 'loan_merges/APPROVE_LOAN_MERGE'
export const REJECT_LOAN_MERGE = 'loan_merges/REJECT_LOAN_MERGE'
export const DELETE_LOAN_MERGE = 'loan_merges/DELETE_LOAN_MERGE'
export const START_LOADING_LOAN_MERGE = 'loan_merges/START_LOADING_LOAN_MERGE'
export const STOP_LOADING_LOAN_MERGE = 'loan_merges/STOP_LOADING_LOAN_MERGE'